// ── Shared WebGL capability pre-check ───────────────────────────────────────
// Runs a throwaway canvas WebGL context test **once** at module level, releases
// the test context immediately, and caches the boolean result. Repeated mounts
// and retries never accumulate live WebGL contexts — important on iOS Safari,
// which enforces a small concurrent-context cap and evicts the oldest context.

let cachedResult: boolean | null = null;

export function checkWebGLCapability(): boolean {
  if (cachedResult !== null) return cachedResult;

  try {
    const canvas = document.createElement('canvas');
    const gl =
      canvas.getContext('webgl2') ??
      canvas.getContext('webgl') ??
      canvas.getContext('experimental-webgl');

    if (!gl) {
      cachedResult = false;
      return false;
    }

    // Release the test context so it doesn't count against the browser's
    // concurrent WebGL context limit (especially iOS Safari ~16 cap).
    const ext = (gl as WebGLRenderingContext).getExtension('WEBGL_lose_context');
    if (ext) ext.loseContext();

    cachedResult = true;
    return true;
  } catch {
    cachedResult = false;
    return false;
  }
}
